import React, { useState, useEffect } from "react";
import VoiceAssistantCard from "../../../components/Dashboard/Teacher/VoiceAssistantCard";
import AIAppsGrid from "../../../components/Dashboard/Teacher/AIAppsGrid";
import {
  getFollowups,
  deleteFollowup,
  deleteFollowupLC,
  getFollowupsLC,
} from "../../../services/operations/followupAPI";
import { useNavigate } from "react-router-dom";
import FollowUpCard from "../../../components/Dashboard/FollowUpCard";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

export default function Teacher() {
  //const { user } = useSelector((state) => state.profile);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [followUps, setFollowUps] = useState([]);
  const [followUpLc, setFollowUpLc] = useState([]);


  const handleFollowupClick = (followup) => {
    navigate(`/dashboard/student/chatbot/${followup.conversation_id}`);

    dispatch(deleteFollowup(followup._id));
  };

  const handleFollowupLcClick = (followup) => {
    navigate(`/dashboard/student/chatbot/${followup.conversation_id}`);

    dispatch(deleteFollowupLC(followup._id));
  };

    useEffect(() => {
      const fetchData = async () => {
        const data = await getFollowups()();
        // console.log("follow response", data);
  
        if (data?.messages && Array.isArray(data.messages)) {
          setFollowUps(data.messages);
        } else {
          setFollowUps([]);
        }
      };
      fetchData();
    }, []);
  
    useEffect(() => {
      const fetchData = async () => {
        const data = await getFollowupsLC()();
        // console.log("followlc response", data);
  
        if (data?.messages && Array.isArray(data.messages)) {
          setFollowUpLc(data.messages);
        } else {
          setFollowUpLc([]);
        }
      };
      fetchData();
    }, []);

  return (
    <main className="bg-[#f7fafd] min-h-screen ">
      <div className="max-w-7xl mx-auto p-6 sm:p-10">
        <VoiceAssistantCard />
          {/* Scrollable Follow-ups */}
          <div className="mb-8 mt-6">
            <h3 className="text-lg font-bold text-gray-700 mb-3">
              📌 {t("teacher.followups")}
            </h3>
            <div className="space-y-3 max-h-64 overflow-y-auto pr-2 scrollbar-thin scrollbar-thumb-yellow-400 scrollbar-track-yellow-100 rounded-lg overflow-x-hidden">
              {followUps.length === 0 && followUpLc.length === 0 ? (
                <p className="text-gray-500 text-sm">
                  {t("teacher.noFollowups")}
                </p>
              ) : (
                <>
                  {followUps.map((item) => (
                    <div
                      key={item._id}
                      onClick={() => handleFollowupClick(item)}
                      className="cursor-pointer hover:brightness-95 hover:shadow-lg transition-all duration-200"
                    >
                      <FollowUpCard
                        message={item.message || item.current_topic}
                        summary={item.summary || item.suggestion_text}
                        topic={item.topic || item.current_subject}
                      />
                    </div>
                  ))}

                  {followUpLc.map((item) => (
                    <div
                      key={item._id}
                      onClick={() => handleFollowupLcClick(item)}
                      className="cursor-pointer hover:brightness-95 hover:shadow-lg transition-all duration-200"
                    >
                      <FollowUpCard
                        message={item.current_topic}
                        summary={item.suggestion_text}
                        topic={item.current_subject}
                      />
                    </div>
                  ))}
                </>
              )}
            </div>
          </div>
        <AIAppsGrid />
      </div>
    </main>
  );
}
